jQuery(document).ready(function ($) {
  // // === Full Fresh Page Load Snippet === //

  // // 1. Prevent browser from restoring scroll or page state
  // if ("scrollRestoration" in history) {
  //   history.scrollRestoration = "manual";
  // }

  // // 2. On page load, scroll to top immediately
  // window.addEventListener("load", () => {
  //   window.scrollTo(0, 0);
  // });

  // // 3. Optional: Clear forms or other persisted state if needed
  // window.addEventListener("beforeunload", () => {
  //   // Clear any inputs or local form state
  //   document.querySelectorAll("input, textarea, select").forEach((el) => {
  //     el.value = "";
  //   });
  // });

  // // 4. Optional: Force cache bypass for certain resources (images, scripts, CSS)
  // const bustCache = () => {
  //   const links = document.querySelectorAll(
  //     'link[rel="stylesheet"], script[src]',
  //   );
  //   links.forEach((el) => {
  //     const url = new URL(el.href || el.src);
  //     url.searchParams.set("_", Date.now());
  //     if (el.tagName === "LINK") el.href = url.toString();
  //     else el.src = url.toString();
  //   });
  // };

  // // Call cache-buster if you need true fresh assets (can be commented out if not needed)
  // // window.addEventListener('load', bustCache);

  // // === Full Fresh Page Load Snippet === //

  //HEADER//
  function onScroll() {
    var scroll = $(window).scrollTop();

    if (scroll >= 5) {
      $(".section-header").addClass("active_header");
    } else {
      $(".section-header").removeClass("active_header");
    }
  }
  onScroll();
  $(window).on("scroll", function () {
    onScroll();
  });
  //HEADER//

  //GENERAL LOGC FUNCTIONALITY//
  //HREF CLICK//
  $(document).on("click", ".href_click", function () {
    // Get the value of data-href attribute
    var url = $(this).data("href");
    if (url) {
      window.location.href = url;
    }
  });
  //HREF CLICK//
  
  //video click functionality
  //video with iframe
  $(".click.vid_iframe").click(function () {
    if ($(this).hasClass("active")) {
      $(this).find("video")[0].pause();
    } else {
      var videoIframe = $(this).find("iframe");
      console.log(videoIframe);
      var videoSrc = videoIframe.attr("src");
      console.log(videoSrc);
      var symbol = $(this).find("iframe")[0].src.indexOf("?") > -1 ? "&" : "?";
      //modify source to autoplay and start video
      $(this).find("iframe")[0].src += symbol + "autoplay=1";
      // $(this).find("iframe").attr("autoplay", "1");

      $(this).parent().find(".playBtn").css("display", "none");
      $(this).parent().removeClass("click");
    }
  });
  //video with iframe
  //video with normal video tag
  $(".click.video").click(function () {
    if ($(this).hasClass("active")) {
      $(this).find("video")[0].pause();
    } else {
      console.log("tr");
      $(this).find("video")[0].play();
    }
  });
  $("video").on("pause", function () {
    $(this).parent().find(".playBtn").css("display", "flex");
    $($(this).parent().find("video")[0]).removeAttr("controls");
    $(this).parent().addClass("click");
    $(this).removeClass("change_aspect");
  });

  $("video").on("play", function () {
    $(this).parent().find(".playBtn").css("display", "none");
    $(this).parent().removeClass("click");
    $($(this).parent().find("video")[0]).attr("controls", "controls");
    $(this).addClass("change_aspect");
  });
  //video with normal video tag
  //video click functionality

  //FAQ DROPDOWN//
  $(".faq_blocks .faq_block:first .question").addClass("current");
  $(".faq_blocks .faq_block:first .question")
    .parent()
    .find(".answer")
    .slideDown();
  $(".faq_block .question").click(function () {
    if ($(this).hasClass("current")) {
      $(this).removeClass("current");
      $(this).parent().find(".answer").slideUp();
    } else {
      $(".faq_block .question").removeClass("current");
      var active = $(this).attr("data-active");
      console.log("active: ", active);

      $(".dropdown_g .image_g .child").removeClass("active");
      $(".dropdown_g .image_g ." + active).addClass("active");
      $(".faq_block .answer").slideUp();
      $(this).addClass("current");
      $(this).parent().find(".answer").slideDown();
    }
  });
  $(".prd_features_drops .prd_features_drop:first .inline").addClass("current");
  $(".prd_features_drops .prd_features_drop:first .answer").slideDown();
  $(".prd_features_drop .inline").click(function () {
    if ($(this).hasClass("current")) {
      $(this).removeClass("current");
      $(this).parent().find(".answer").slideUp();
    } else {
      $(".prd_features_drop .inline").removeClass("current");
      $(".prd_features_drop .answer").slideUp();
      $(this).addClass("current");
      $(this).parent().find(".answer").slideDown();
    }
  });
  //FAQ DROPDOWN//
  //GENERAL LOGC FUNCTIONALITY//

  //REVEAL TEXT - GSAP//
  // Register ScrollTrigger only once
  if (!gsap.core.globals().ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  if ($(window).width() > 992) {
    $(".color_reveal.sec_2 .color-reveal-text").each(function () {
      var $el = $(this);
      var text = $.trim($el.text());
      var words = text.split(/\s+/);

      // Adding span around each word in the complete text
      $el.html(
        words
          .map(function (word) {
            return "<span>" + word + "</span>";
          })
          .join(" "),
      );

      var startColor = $el.data("color-start") || "#043B14";
      var endColor = $el.data("color-end") || "#FFFFFF";

      // collection of spans
      var spans = $el.find("span");

      // initial colors
      gsap.set(spans, { color: startColor });

      // timeline for this text
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $el.closest(".sec_2"), // pin the whole section
          start: "top top",
          // end: "+=150%",
          end: "+=70%", //animation speed
          // end: "bottom top",
          scrub: true,
          pin: true,
          // pinSpacing: true
        },
      });

      // Animate color change word by word
      spans.each(function (i, span) {
        tl.to(
          span,
          {
            color: endColor,
            ease: "none",
            duration: 0.2,
          },
          i * 0.05,
        );
      });
    });
  }
  //REVEAL TEXT - GSAP//
});
